import * as Yup from 'yup'

Yup.setLocale({
  mixed: {
    required: 'Campo obrigatório',
  },
})

export default Yup
